
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-pxp-setup]').forEach((list) => {
    const root = list.closest('.pxp-setup');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const items = [...root.querySelectorAll('[data-pxp-item]')];
    const totalEl = root.querySelector('[data-pxp-total]');
    const addBtn = root.querySelector('[data-pxp-add]');
    const status = root.querySelector('[data-pxp-status]');

    const money = (cents) =>
      new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' })
        .format(cents / 100);

    const recalc = () => {
      let total = 0;
      items.forEach((item) => {
        const check = item.querySelector('[data-pxp-check]');
        if (!check?.checked) return;
        const select = item.querySelector('[data-pxp-select]');
        const cents = select
          ? Number(select.options[select.selectedIndex]?.dataset.price || 0)
          : Number(item.dataset.price || 0);
        total += cents;
      });
      if (totalEl) totalEl.textContent = total ? money(total) : '';
    };

    items.forEach((item) => {
      const select = item.querySelector('[data-pxp-select]');
      const check = item.querySelector('[data-pxp-check]');
      select?.addEventListener('change', () => {
        const opt = select.options[select.selectedIndex];
        item.dataset.variantId = opt.value;
        item.dataset.price = opt.dataset.price || '0';
        const price = item.querySelector('[data-pxp-price]');
        if (price) price.textContent = money(Number(item.dataset.price || 0));
        recalc();
      });
      check?.addEventListener('change', recalc);
    });

    addBtn?.addEventListener('click', async () => {
      const selected = items
        .filter((item) => item.querySelector('[data-pxp-check]')?.checked)
        .map((item) => ({ id: Number(item.dataset.variantId), quantity: 1 }));

      if (!selected.length) {
        if (status) status.textContent = 'Select at least one item.';
        return;
      }

      addBtn.disabled = true;
      if (status) status.textContent = '';

      try {
        const res = await fetch(window.Shopify?.routes?.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: selected })
        });
        if (!res.ok) throw new Error();
        if (status) status.textContent = 'Added to cart.';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (e) {
        if (status) status.textContent = 'Unable to add these items.';
      } finally {
        addBtn.disabled = false;
      }
    });

    recalc();
  });
});
